export function getTimezoneInfo() {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  const now = new Date();
  const utcNow = now.toISOString();

  // Local time in user's IANA timezone (if available)
  let localNow = null;
  let tzShort = null;
  let tzLong = null;
  try {
    if (timezone) {
      localNow = now.toLocaleString("en-US", { timeZone: timezone });

      const shortParts = Intl.DateTimeFormat("en-US", {
        timeZone: timezone,
        timeZoneName: "short",
      })
        .formatToParts(now)
        .find((p) => p.type === "timeZoneName");
      tzShort = shortParts?.value || null;

      const longParts = Intl.DateTimeFormat("en-US", {
        timeZone: timezone,
        timeZoneName: "long",
      })
        .formatToParts(now)
        .find((p) => p.type === "timeZoneName");
      tzLong = longParts?.value || null;
    } else {
      localNow = now.toString();
    }
  } catch (e) {
    localNow = now.toString();
    tzShort = null;
    tzLong = null;
  }

  // UTC offset calculations
  // getTimezoneOffset returns minutes behind UTC (negative if ahead), so invert sign
  const offsetMinutes = -now.getTimezoneOffset();
  const offsetSign = offsetMinutes >= 0 ? "+" : "-";
  const absMinutes = Math.abs(offsetMinutes);
  const offsetHours = Math.floor(absMinutes / 60);
  const offsetMins = absMinutes % 60;
  const utcOffsetString = `${offsetSign}${String(offsetHours).padStart(2, "0")}:${String(offsetMins).padStart(2, "0")}`;
  const utcOffsetDecimal = (offsetMinutes / 60).toFixed(2); // e.g. 5.50 for +5:30

  return {
    timezone,
    utcNow,
    localNow,
    timezoneShort: tzShort,
    timezoneLong: tzLong,
    utcOffsetString,
    utcOffsetMinutes: offsetMinutes,
    utcOffsetDecimal,
  };
}

export default getTimezoneInfo;
